import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ForecastService {

  constructor(private httpClient: HttpClient, private toastr: ToastrService) { }
  private apiUrl = environment.apiUrl;

  getForecastList(deviceId:string): Observable<any> {
    return this.httpClient.get(`${this.apiUrl}/Report/DataForecasting?deviceId=${deviceId}`).pipe(
      //catchError(this.error)
    );;
  }  
  getFarmSensorsList(): Observable<any> {
    return this.httpClient.get(`${this.apiUrl}/Farms/GetFarmhouseSensorsList`).pipe(
      
    );
  }
}
